<template>
    <div>
        <v-card :loading="loading" class="p-3">
            <div class="mx-md-auto row py-4">
                <div class="row mx-auto">
                       <p class="col-md-9 d-block mb-0"><span class="text-danger">توجه ! </span> آگهی های یافت شده ظرف 72 ساعت
                           آینده حذف خواهند شد.</p>
<!--                    <p class="col-md text-left">تعداد کل : <span class="text-danger">{{archivesCount}}</span></p>-->
                </div>
                <div class="col-12">
                    <v-btn
                            small
                            :disabled="groupID.length<=0"
                            class="btn-download bg-white"
                            @click="multiTransferPost"
                    >
                        <span class="fa fa-exchange-alt ml-1" style="font-size: 1.2rem"></span>
                        انتقال گروهی آگهی ها
                    </v-btn>
                </div>
                <v-col class="col-md-4" v-for="item in  archives">
                    <v-card color="#191179" dark class="text-white" max-height="300" min-height="155" elevation="4"
                            :key="item.post.token">
                        <div class="d-flex flex-no-wrap justify-space-between">
                            <div class="mt-2">
                                <v-card-subtitle class="py-2" v-text="item.post.title"></v-card-subtitle>
                                <v-card-subtitle class="py-1" v-text="item.post.top_description_text"></v-card-subtitle>
                                <v-card-subtitle class="py-1"
                                                 v-text="item.post.middle_description_text"></v-card-subtitle>
                                <v-card-subtitle class="py-1"
                                                 v-text="item.post.bottom_description_text"></v-card-subtitle>
                            </div>
                            <v-avatar class="ma-3 ml-0" size="100">
                                <v-img
                                        :src="item.post.images.length > 0 && item.post.images[0] !== null ? item.post.images[0] : require('@/assets/img/rblandNotext.png')"></v-img>
                            </v-avatar>
                            <div class="p-0 mt-1">
                                <v-checkbox
                                        color="pink"
                                        v-model="groupID"
                                        :key="item.post.token"
                                        :value="item.post.token"
                                        class="mt-1"
                                ></v-checkbox>
                                <v-speed-dial
                                        :key="item.post.token"
                                        :right="right"
                                        :direction="direction"
                                        :open-on-hover="hover"
                                        :transition="transition"
                                >
                                    <template v-slot:activator>
                                        <v-btn
                                                v-model="fab"
                                                icon
                                        >
                                            <v-icon v-if="fab" color="pink darken-1">mdi-close</v-icon>
                                            <span v-else class="svg-icon svg-icon-light">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                 width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <rect x="0" y="0" width="24" height="24"/>
                                <circle fill="#000000" cx="12" cy="5" r="2"/>
                                <circle fill="#000000" cx="12" cy="12" r="2"/>
                                <circle fill="#000000" cx="12" cy="19" r="2"/>
                            </g>
                        </svg>
                        </span>
                                        </v-btn>
                                    </template>
                                    <v-btn
                                            fab
                                            dark
                                            v-b-tooltip title="انتقال تکی آگهی"
                                            @click="transferPost(item.post.token)"
                                            x-small
                                            class="btn-dec-with-text bg-white rounded-circle"
                                    >
                                        <span class="fa fa-exchange-alt" style="font-size: 1.2rem"></span>
                                    </v-btn>
                                    <v-btn
                                            fab
                                            dark
                                            x-small
                                            @click="divarAds(item.post.url)"
                                            class="btn-upload bg-white rounded-circle"
                                            v-b-tooltip title="مشاهده آگهی در دیوار"
                                    >
                                        <span class="fa fa-paper-plane" style="font-size: 1.1rem"></span>
                                    </v-btn>
                                </v-speed-dial>
                            </div>
                        </div>
                    </v-card>
                </v-col>
            </div>
            <a id="dl" ref="dl"></a>
            <atom-spinner
                    v-if="loading"
                    :animation-duration="1500"
                    :size="60"
                    class="mx-auto"
                    color="indigo"
            />
        </v-card>
    </div>
</template>

<script>
import {AtomSpinner, HalfCircleSpinner, HollowDotsSpinner} from 'epic-spinners'
import {Axios2} from "../../../../main";

export default {
    name: "allPosts",
    components: {
        HollowDotsSpinner, HalfCircleSpinner, AtomSpinner
    },
    data() {
        return {
            loading: false,
            observer: null,
            fab: false,
            groupTransfer: false,
            next_page: null,
            direction: 'right',
            top: false,
            groupID: [],
            right: false,
            bottom: true,
            archivesCount:'0',
            transition: 'slide-y-reverse-transition',
            archives: [],
            url: `${url}/user/recent/posts`
        }
    },
    methods: {
        getAds(url = this.url) {
            this.loading = true;
            Axios2.get(url, {
                params: {
                    order: "id",
                    dir: "desc"
                }
            }).then((response) => {
                this.loading = false;
                this.archives = this.archives.concat(response.data.data.data);
                this.next_page = response.data.data.next_page_url.replace('http://', 'https://');
                this.next_page = response.data.data.next_page_url;
                this.observer.observe(this.$refs.dl);
            });
        },
        transferPost(token) {
            this.$modal.yesNo('تایید انتقال', 'آیا از اضافه کردن این آگهی به لیست تازه های دیوار خود اطمینان دارید؟', 'dont').then((response) => {
                if (response) {
                    this.$modal.showLoading();
                    Axios2.post(`/user/estate/store/${token}`).then((res) => {
                        this.$modal.hideLoading();
                        this.$modal.success('موفقیت آمیز!', res.data.message);
                        this.archives = [];
                        this.getAds(this.url);
                        this.observer.unobserve(this.$refs.dl);
                    })
                }
            })
        },
        multiTransferPost(token) {
            this.groupTransfer = true;
            if (this.groupID.length > 0) {
                this.$modal.yesNo('تایید انتقال', 'آیا از اضافه کردن این آگهی به لیست تازه های دیوار خود اطمینان دارید؟', 'dont').then((response) => {
                    if (response) {
                        this.$modal.showLoading();
                        Axios2.post('user/estate/mass/store', {tokens: this.groupID}).then((res) => {
                            this.$modal.hideLoading();
                            this.$modal.success('موفقیت آمیر!', res.data.message);
                            this.groupTransfer = false;
                            this.archives = [];
                            this.groupID = [];
                            this.getAds(this.url);
                            this.observer.unobserve(this.$refs.dl);
                        })
                    }
                })
            }
        },
        divarAds(AdsUrl) {
            window.open(AdsUrl, '_blank')
        }
    },
    watch:{
        archives(value){
      this.archivesCount=value.length
        }
    },
    mounted() {
        this.getAds();
        this.observer = new IntersectionObserver((entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && this.next_page !== null) {
                    this.observer.unobserve(this.$refs.dl);
                    this.getAds(this.next_page);
                }
            });
        }));
    }
}
</script>

<style scoped>

</style>